import styled from 'styled-components'

export const HeaderContainer = styled.div`
  background-color: #f1f5f9;
`

export const HeaderImage = styled.img`
  width: 180px;
  margin-top: 15px;
  margin-bottom: 15px;
  margin-left: 80px;
`
